import { sortFulfillmentOrderLineItems } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { FulfillmentOrderLineItem } from "@redotech/redo-model/fulfillments/fulfillment-order-line-item";
import { ItemOrderBy } from "@redotech/redo-model/outbound-labels";
import { Team } from "@redotech/redo-model/team";
import { Flex } from "@redotech/redo-web/flex";
import {
  ItemTableHeader,
  ProductListRow,
} from "@redotech/redo-web/product-list-row";
import { memo, useMemo } from "react";

export const ItemsTable = memo(function ItemsTable({
  items,
  team,
  disableTooltip = false,
  hideHeader = false,
  showBin = false,
}: {
  items: FulfillmentOrderLineItem[];
  team: Team | undefined;
  disableTooltip?: boolean;
  hideHeader?: boolean;
  showBin?: boolean;
}) {
  const sortedItems = useMemo(() => {
    return sortFulfillmentOrderLineItems(
      team?.settings?.outboundLabels?.documents?.pickList?.orderBy ??
        ItemOrderBy.QuantityDesc,
      items,
    ).filter((item) => item.quantity > 0);
    // FIXME
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  const showCustomAttributes =
    !!team?.settings?.outboundLabels?.degroupItemsByCustomAttributes;
  const hideUnderscoreCustomAttributes =
    !!team?.settings?.outboundLabels?.hideUnderscoreCustomAttributes;

  return (
    <Flex
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      dir="column"
      gap="none"
      radius="sm"
    >
      {!hideHeader && (
        <ItemTableHeader flatTopCorners={false} showBin={showBin} />
      )}
      <Flex dir="column" flex="1" gap="none">
        {sortedItems.map((item, index) => (
          <Flex
            borderBottomWidth={index !== items.length - 1 ? "1px" : "none"}
            borderColor="secondary"
            borderStyle="solid"
            gap="none"
            key={index}
            w="full"
          >
            <ProductListRow
              bin={showBin ? item.bin : undefined}
              customAttributes={
                showCustomAttributes
                  ? hideUnderscoreCustomAttributes
                    ? item.customAttributes?.filter(
                        (attr) => !attr.key.startsWith("_"),
                      )
                    : item.customAttributes
                  : undefined
              }
              disableTooltip={disableTooltip}
              imageUrl={item.imageUrl}
              price={item.unitDiscountedPrice.amount}
              quantity={item.quantity}
              sku={item.sku}
              title={item.productTitle || item.title}
              variantTitle={item.variantTitle}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
});
